// extracted by mini-css-extract-plugin
module.exports = {"PreloaderContainer":"Spinner_PreloaderContainer__522bt","Preloader":"Spinner_Preloader__i9bLR","spinner":"Spinner_spinner__dYTEm","rotating":"Spinner_rotating__0CEie"};